// extracted by mini-css-extract-plugin
module.exports = {"container":"globalCheck_container__Xukue","uncheck":"globalCheck_uncheck__cqrt5"};